import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        wrapper: {
            zIndex: 'overlay',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'whiteAlpha.800',
        },
        spinner: {
            position: 'absolute',
            top: '50%',
            left: '50%',
            ml: '-1.5em',
            mt: '-1.5em',
            thickness: remCalc(4),
            speed: '0.65s',
            emptyColor: 'label.background.disable',
            color: 'icons.background.secondary',
            size: 'xl',
        },
    },
}
